import React, { useState } from "react";
import {
  FormControlLabel,
  Switch,
  Typography,
  Button,
  TextField,
  Box,
  Divider,
} from "@mui/material";
import ProductSection from "../../ProductsModule/Components/ProductSection";
import { Bell, Mail, Smartphone, Info } from "lucide-react";

const NotificationSettings = () => {
  // Email notification states
  const [orderConfirmations, setOrderConfirmations] = useState(true);
  const [stockAlerts, setStockAlerts] = useState(true);
  const [paymentReminders, setPaymentReminders] = useState(true);
  const [newsletterUpdates, setNewsletterUpdates] = useState(false);
  const [securityAlerts, setSecurityAlerts] = useState(true);

  // SMS notification states
  const [smsOrderConfirmations, setSmsOrderConfirmations] = useState(false);
  const [smsStockAlerts, setSmsStockAlerts] = useState(false);
  const [smsPaymentReminders, setSmsPaymentReminders] = useState(true);

  // In-app notification states
  const [appOrderUpdates, setAppOrderUpdates] = useState(true);
  const [appInventoryAlerts, setAppInventoryAlerts] = useState(true);
  const [appCustomerActivities, setAppCustomerActivities] = useState(true);
  const [appSystemNotifications, setAppSystemNotifications] = useState(true);

  return (
    <div className="space-y-8">
      {/* Email Notifications */}
      <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
        <div className="flex items-center mb-4">
          <Mail size={20} className="text-[#5652B0] mr-2" />
          <ProductSection data={"Email Notifications"} />
        </div>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 3, fontFamily: "Outfit" }}>
          Configure which email notifications you want to receive
        </Typography>

        <div className="space-y-3">
          <FormControlLabel
            control={
              <Switch
                checked={orderConfirmations}
                onChange={e => setOrderConfirmations(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#5652B0",
                    "&:hover": {
                      backgroundColor: "rgba(86, 82, 176, 0.08)",
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#5652B0",
                  },
                }}
              />
            }
            label={
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Outfit", fontWeight: 500 }}>
                  Order Confirmations
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontFamily: "Outfit" }}>
                  Receive emails for new orders and order status changes
                </Typography>
              </div>
            }
            sx={{ display: "flex", alignItems: "flex-start", marginLeft: 0 }}
          />

          <Divider />

          <FormControlLabel
            control={
              <Switch
                checked={stockAlerts}
                onChange={e => setStockAlerts(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#5652B0",
                    "&:hover": {
                      backgroundColor: "rgba(86, 82, 176, 0.08)",
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#5652B0",
                  },
                }}
              />
            }
            label={
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Outfit", fontWeight: 500 }}>
                  Stock Level Alerts
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontFamily: "Outfit" }}>
                  Receive alerts when products are low in stock or out of stock
                </Typography>
              </div>
            }
            sx={{ display: "flex", alignItems: "flex-start", marginLeft: 0 }}
          />

          <Divider />

          <FormControlLabel
            control={
              <Switch
                checked={paymentReminders}
                onChange={e => setPaymentReminders(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#5652B0",
                    "&:hover": {
                      backgroundColor: "rgba(86, 82, 176, 0.08)",
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#5652B0",
                  },
                }}
              />
            }
            label={
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Outfit", fontWeight: 500 }}>
                  Payment Reminders
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontFamily: "Outfit" }}>
                  Receive reminders about due payments and upcoming invoices
                </Typography>
              </div>
            }
            sx={{ display: "flex", alignItems: "flex-start", marginLeft: 0 }}
          />

          <Divider />

          <FormControlLabel
            control={
              <Switch
                checked={newsletterUpdates}
                onChange={e => setNewsletterUpdates(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#5652B0",
                    "&:hover": {
                      backgroundColor: "rgba(86, 82, 176, 0.08)",
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#5652B0",
                  },
                }}
              />
            }
            label={
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Outfit", fontWeight: 500 }}>
                  Newsletter & Updates
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontFamily: "Outfit" }}>
                  Receive news, announcements and product updates
                </Typography>
              </div>
            }
            sx={{ display: "flex", alignItems: "flex-start", marginLeft: 0 }}
          />

          <Divider />

          <FormControlLabel
            control={
              <Switch
                checked={securityAlerts}
                onChange={e => setSecurityAlerts(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#5652B0",
                    "&:hover": {
                      backgroundColor: "rgba(86, 82, 176, 0.08)",
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#5652B0",
                  },
                }}
              />
            }
            label={
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Outfit", fontWeight: 500 }}>
                  Security Alerts
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontFamily: "Outfit" }}>
                  Receive alerts about security-related activities in your
                  account
                </Typography>
              </div>
            }
            sx={{ display: "flex", alignItems: "flex-start", marginLeft: 0 }}
          />
        </div>
      </div>

      {/* SMS Notifications */}
      <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
        <div className="flex items-center mb-4">
          <Smartphone size={20} className="text-[#5652B0] mr-2" />
          <ProductSection data={"SMS Notifications"} />
        </div>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 3, fontFamily: "Outfit" }}>
          Configure which SMS notifications you want to receive
        </Typography>

        <div className="mb-4">
          <TextField
            label="Phone Number"
            variant="outlined"
            size="small"
            defaultValue="+91 8976543210"
            fullWidth
            sx={{
              maxWidth: "400px",
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#5652B0",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#5652B0",
              },
            }}
          />
        </div>

        <div className="space-y-3">
          <FormControlLabel
            control={
              <Switch
                checked={smsOrderConfirmations}
                onChange={e => setSmsOrderConfirmations(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#5652B0",
                    "&:hover": {
                      backgroundColor: "rgba(86, 82, 176, 0.08)",
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#5652B0",
                  },
                }}
              />
            }
            label={
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Outfit", fontWeight: 500 }}>
                  Order Confirmations
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontFamily: "Outfit" }}>
                  Receive SMS for new orders and order status changes
                </Typography>
              </div>
            }
            sx={{ display: "flex", alignItems: "flex-start", marginLeft: 0 }}
          />

          <Divider />

          <FormControlLabel
            control={
              <Switch
                checked={smsStockAlerts}
                onChange={e => setSmsStockAlerts(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#5652B0",
                    "&:hover": {
                      backgroundColor: "rgba(86, 82, 176, 0.08)",
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#5652B0",
                  },
                }}
              />
            }
            label={
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Outfit", fontWeight: 500 }}>
                  Stock Level Alerts
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontFamily: "Outfit" }}>
                  Receive SMS alerts when products are low in stock or out of
                  stock
                </Typography>
              </div>
            }
            sx={{ display: "flex", alignItems: "flex-start", marginLeft: 0 }}
          />

          <Divider />

          <FormControlLabel
            control={
              <Switch
                checked={smsPaymentReminders}
                onChange={e => setSmsPaymentReminders(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#5652B0",
                    "&:hover": {
                      backgroundColor: "rgba(86, 82, 176, 0.08)",
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#5652B0",
                  },
                }}
              />
            }
            label={
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Outfit", fontWeight: 500 }}>
                  Payment Reminders
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontFamily: "Outfit" }}>
                  Receive SMS reminders about due payments and upcoming invoices
                </Typography>
              </div>
            }
            sx={{ display: "flex", alignItems: "flex-start", marginLeft: 0 }}
          />
        </div>
      </div>

      {/* In-App Notifications */}
      <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
        <div className="flex items-center mb-4">
          <Bell size={20} className="text-[#5652B0] mr-2" />
          <ProductSection data={"In-App Notifications"} />
        </div>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 3, fontFamily: "Outfit" }}>
          Configure which in-app notifications you want to receive
        </Typography>

        <div className="space-y-3">
          <FormControlLabel
            control={
              <Switch
                checked={appOrderUpdates}
                onChange={e => setAppOrderUpdates(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#5652B0",
                    "&:hover": {
                      backgroundColor: "rgba(86, 82, 176, 0.08)",
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#5652B0",
                  },
                }}
              />
            }
            label={
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Outfit", fontWeight: 500 }}>
                  Order Updates
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontFamily: "Outfit" }}>
                  Receive notifications for new orders and status changes
                </Typography>
              </div>
            }
            sx={{ display: "flex", alignItems: "flex-start", marginLeft: 0 }}
          />

          <Divider />

          <FormControlLabel
            control={
              <Switch
                checked={appInventoryAlerts}
                onChange={e => setAppInventoryAlerts(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#5652B0",
                    "&:hover": {
                      backgroundColor: "rgba(86, 82, 176, 0.08)",
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#5652B0",
                  },
                }}
              />
            }
            label={
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Outfit", fontWeight: 500 }}>
                  Inventory Alerts
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontFamily: "Outfit" }}>
                  Get notified about inventory changes and stock levels
                </Typography>
              </div>
            }
            sx={{ display: "flex", alignItems: "flex-start", marginLeft: 0 }}
          />

          <Divider />

          <FormControlLabel
            control={
              <Switch
                checked={appCustomerActivities}
                onChange={e => setAppCustomerActivities(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#5652B0",
                    "&:hover": {
                      backgroundColor: "rgba(86, 82, 176, 0.08)",
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#5652B0",
                  },
                }}
              />
            }
            label={
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Outfit", fontWeight: 500 }}>
                  Customer Activities
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontFamily: "Outfit" }}>
                  Get notified about customer registrations and updates
                </Typography>
              </div>
            }
            sx={{ display: "flex", alignItems: "flex-start", marginLeft: 0 }}
          />

          <Divider />

          <FormControlLabel
            control={
              <Switch
                checked={appSystemNotifications}
                onChange={e => setAppSystemNotifications(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#5652B0",
                    "&:hover": {
                      backgroundColor: "rgba(86, 82, 176, 0.08)",
                    },
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#5652B0",
                  },
                }}
              />
            }
            label={
              <div>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Outfit", fontWeight: 500 }}>
                  System Notifications
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontFamily: "Outfit" }}>
                  Receive system updates, maintenance alerts, and other
                  announcements
                </Typography>
              </div>
            }
            sx={{ display: "flex", alignItems: "flex-start", marginLeft: 0 }}
          />
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end space-x-4 mt-6">
        <Button
          variant="outlined"
          sx={{
            borderColor: "#5652B0",
            color: "#5652B0",
            textTransform: "none",
            fontFamily: "Outfit",
            "&:hover": {
              borderColor: "#4A47A3",
              backgroundColor: "rgba(86, 82, 176, 0.04)",
            },
          }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#5652B0",
            color: "white",
            textTransform: "none",
            fontFamily: "Outfit",
            "&:hover": {
              backgroundColor: "#4A47A3",
            },
          }}>
          Save Changes
        </Button>
      </div>
    </div>
  );
};

export default NotificationSettings;
